import { GET_ALL_EXAMS_IN_PROGRESS, GET_DASHBOARD_OVERVIEW, GET_OVERALL_COMPLETED_COUNT } from '../actions/types';

const initialState = {
  overview_details: {},
  overall_compeleted_count: 0,
  all_exam_in_progress: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DASHBOARD_OVERVIEW:
      return {
        ...state,
        overview_details: action.payload,
      };
    case GET_ALL_EXAMS_IN_PROGRESS:
      return {
        ...state,
        all_exam_in_progress: action.payload,
      };
    case GET_OVERALL_COMPLETED_COUNT:
      return {
        ...state,
        overall_completed_count: action.payload,
      };
    default:
      return state;
  }
}
